/**
 * simple matchHeight - quick utility to force card titles to be the same height
 * @todo: expand to work with multiple instances on the same page
 *
 **/
;(function matchHeight() {
  // Grab all of the divs we need to matchHeight
  let mhDivs = document.body.querySelectorAll('[data-mh]')

  // Set divs into corresponding groups
  let mhDivGroups = {}

  // Iterate through mhDivs and find common groups
  mhDivs.forEach(mhDiv => {
    let attr = mhDiv.dataset.mh ?? false
    if (attr && !mhDivGroups.hasOwnProperty(attr)) {
      // create group array
      mhDivGroups[attr] = []
    }
    // add element to group
    mhDivGroups[attr].push(mhDiv)
  })

  // Iterate through and find the tallest div
  const setMaxHeight = function(mhDivs) {
    let maxHeight = 0

    mhDivs.forEach(el => {
      let height = el.offsetHeight
      if (maxHeight < height) {
        maxHeight = height
      }
    })
    return maxHeight
  }

  // Iterate through mhDivs and set all their height style equal to the maxHeight
  const setHeights = function(mhDivs, maxHeight) {
    mhDivs.forEach(el => {
      el.style.height = maxHeight + 'px'
    })
  }

  // Iterate through groups and set maxHeight for each group
  Object.entries(mhDivGroups).forEach(([, els]) => {
    let groupMaxHeight = setMaxHeight(els)
    setHeights(els, groupMaxHeight)
  })
})()
